import { IDrugCardInfo } from '@pharmsnap/shared/types'
import { CTRL_C_INFO } from '@pharmsnap/shared/utils'
import { defineComponent, PropType } from '@vue/composition-api'
import '../../../../assets/icon-svg/drug.svg'
import { BMicroEntityCard } from '../BMicroEntityCard/BMicroEntityCard'
import $classes from '../EntityCard.module.scss'
import cmpCn from '../locales/cn.json'
import cmpEn from '../locales/en.json'
import cn from './locales/cn.json'
import en from './locales/en.json'

export const BDrugCard = defineComponent({
  name: 'BDrugCard',
  i18n: {
    messages: {
      cn: { ...cn, ...cmpCn },
      en: { ...en, ...cmpEn },
    },
  },
  props: {
    data: {
      type: Object as PropType<IDrugCardInfo>,
    },
    id: {
      type: String,
      required: true,
    },
    // singleNamePlaceholder: {
    //   type: Boolean,
    //   default: false,
    // },
    // showFooter: {
    //   type: Boolean,
    //   default: false,
    // },
    /** 是否使用浅色边框：搜索结果页边框使用 gray-40 */
    isLighterBorder: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: 'horizontal',
    },
    border: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, ctx) {
    return {}
  },
  methods: {
    renderContent() {
      return <BMicroEntityCard id={this.id} type="drug" direction={this.direction} data={this.data} onLoaded={() => this.$emit('loaded')} />
    },
  },
  render() {
    return (
      <div class={[$classes.card, CTRL_C_INFO, this.isLighterBorder && 'border-gray-40', !this.border && $classes.cardNoBorder]}>
        <div class={$classes.body}>{this.renderContent()}</div>
      </div>
    )
  },
})
